import { render, staticRenderFns } from "./RoomLeftTopStatus.vue?vue&type=template&id=45ac17ba&scoped=true"
import script from "./RoomLeftTopStatus.vue?vue&type=script&lang=js"
export * from "./RoomLeftTopStatus.vue?vue&type=script&lang=js"
import style0 from "./RoomLeftTopStatus.vue?vue&type=style&index=0&id=45ac17ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ac17ba",
  null
  
)

export default component.exports